import * as React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export default class NavMenu extends React.PureComponent<{}, { isOpen: boolean }> {
    public state = {
        isOpen: false
    };

    public render() {
        return (
            <header>
                <Navbar className="navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
                    <Container>
                        <NavbarBrand tag={Link} to="/">Andrew Black</NavbarBrand>
                        <NavbarToggler onClick={this.toggle} className="navbar-toggler navbar-toggler-right text-uppercase font-weight-bold bg-primary text-white rounded"/>
                        <Collapse className="collapse navbar-collapse" isOpen={this.state.isOpen} navbar>
                            <ul className="navbar-nav ml-auto">
                                <NavItem className="nav-item mx-0 mx-lg-1">
                                    <NavLink tag={Link} className="nav-link py-3 px-0 px-lg-3 rounded" to="/">Home</NavLink>
                                </NavItem>
                                <NavItem className="nav-item mx-0 mx-lg-1">
                                    <NavLink tag={Link} className="nav-link py-3 px-0 px-lg-3 rounded" to="/counter">Counter</NavLink>
                                </NavItem>
                                <NavItem className="nav-item mx-0 mx-lg-1">
                                    <NavLink tag={Link} className="nav-link py-3 px-0 px-lg-3 rounded" to="/projects">Projects</NavLink>
                                </NavItem>
                                <NavItem className="nav-item mx-0 mx-lg-1">
                                    <NavLink tag={Link} className="nav-link py-3 px-0 px-lg-3 rounded" to="/fetch-data">Fetch data</NavLink>
                                </NavItem>
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }

    private toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
}
